// ═══════════════════════════════════════════════════════════
// Formatting Utilities — Currency, numbers, phone
// ═══════════════════════════════════════════════════════════

/** Format as USD: $1,234.56 */
export function fmtUSD(value: number | string | null | undefined): string {
  const n = typeof value === 'string' ? parseFloat(value) : (value ?? 0);
  if (isNaN(n)) return '$0';
  return '$' + n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

/** Format as compact USD: $1.2M, $45K, $500 */
export function fmtUSDCompact(value: number | string | null | undefined): string {
  const n = typeof value === 'string' ? parseFloat(value) : (value ?? 0);
  if (isNaN(n)) return '$0';
  if (Math.abs(n) >= 1e6) return '$' + (n / 1e6).toFixed(1) + 'M';
  if (Math.abs(n) >= 1000) return '$' + (n / 1000).toFixed(0) + 'K';
  return '$' + n.toFixed(0);
}

/** Format number with commas: 1,234,567 */
export function fmtNum(value: number | string | null | undefined): string {
  const n = typeof value === 'string' ? parseFloat(value) : (value ?? 0);
  if (isNaN(n)) return '0';
  return n.toLocaleString();
}

/** Parse string or number to number, strip currency symbols */
export function parseNum(value: unknown): number {
  if (typeof value === 'number') return isNaN(value) ? 0 : value;
  const s = String(value ?? '');
  if (!s) return 0;
  return parseFloat(s.replace(/[$,]/g, '')) || 0;
}

/** Format phone: (555) 123-4567 */
export function fmtPhone(value: unknown): string {
  if (value === null || value === undefined || value === '') return '';
  const s = String(value);
  const digits = s.replace(/\D/g, '');
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits[0] === '1') return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  return s;
}

/** Format percentage: 45.5% */
export function fmtPct(value: number | string | null | undefined): string {
  const n = typeof value === 'string' ? parseFloat(value) : (value ?? 0);
  if (isNaN(n as number)) return '0%';
  return (n as number).toFixed(1).replace(/\.0$/, '') + '%';
}

/** Capitalize first letter of each word */
export function titleCase(value: unknown): string {
  if (value === null || value === undefined || value === '') return '';
  return String(value).replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
